import { Components } from '@mui/material/styles';
import palette from 'theme/palette';
import pxToEm from 'theme/pxToEm';

export const MuiAutocomplete: Components['MuiAutocomplete'] = {
  defaultProps: {
    disablePortal: true,
  },
  styleOverrides: {
    paper: {
      marginTop: pxToEm(8),
    },
    input: {
      backgroundColor: 'initial',
    },
    popper: {
      '.MuiAutocomplete-listbox': {
        padding: pxToEm(8),

        li: {
          minHeight: pxToEm(32),
          borderRadius: '4px',
          paddingLeft: 'unset',
          fontSize: pxToEm(13),

          '.MuiListItemIcon-root': {
            display: 'flex',
            justifyItems: 'center',
            paddingLeft: pxToEm(6),
          },
          '&:not(:last-of-type)': {
            marginBottom: pxToEm(4),
          },
          '&:hover, &:active, &.Mui-focused': {
            backgroundColor: palette.grey[200],
          },
          '&[aria-selected="true"]:not(&:hover):not(&:active):not(&.Mui-focused)':
            {
              backgroundColor: 'unset!important',
            },
        },
      },
    },
  },
};
